<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core'

import { useCatalogGridStore } from '~/layers/catalog/store/catalogGrid'

const gridStore = useCatalogGridStore()

const isOpened = ref(false)
const isTablet = useMediaQuery('(min-width: 768px)')

const close = () => {
  isOpened.value = false
  document.body.classList.remove('no-scroll')
}

const open = () => {
  isOpened.value = true
  document.body.classList.add('no-scroll')
}
const apply = () => {
  close()
}

watch(isTablet, (tablet) => {
  if (tablet && isOpened.value) close()
})
</script>

<template>
  <div class="catalog__top-text catalog_mobile-only">
    <div @click="open">Сортировка</div>
    <Teleport to="body">
      <div
        v-if="isOpened"
        class="filters filters_active uppercase"
      >
        <div class="filters__menu">
          <div class="filters__top">
            <h3 class="filters__title-mobile">Сортировка</h3>
            <h3 class="filters__title-tablet">Сортировка</h3>
            <div
              class="filters__close"
              @click="close"
            >
              <svg-icon
                height="20"
                name="icon-close"
                width="20"
              />
            </div>
          </div>

          <CatalogSortMobile :items="gridStore.sorting" />

          <CatalogGridLayoutSwitcher />

          <div class="filters__buttons">
            <button
              class="filters__button filters__button_primary apply"
              @click="apply"
            >
              Применить
            </button>
          </div>
        </div>

        <div
          :class="{ filters__overlay_active: isOpened }"
          class="filters__overlay"
          @click="close"
        ></div>
      </div>
    </Teleport>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/components/filters.scss' as *;

.filters__button.apply {
  width: 100%;
}
</style>
